module.exports = __webpack_public_path__ + "media/application/images/svgs/bluetooth-608837444c5ede28c702e1dbf0bcb806.svg";